import { render, staticRenderFns } from "./VersionUpdateList.vue?vue&type=template&id=373f5a10&scoped=true"
import script from "./VersionUpdateList.vue?vue&type=script&lang=js"
export * from "./VersionUpdateList.vue?vue&type=script&lang=js"
import style0 from "./VersionUpdateList.vue?vue&type=style&index=0&id=373f5a10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373f5a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373f5a10')) {
      api.createRecord('373f5a10', component.options)
    } else {
      api.reload('373f5a10', component.options)
    }
    module.hot.accept("./VersionUpdateList.vue?vue&type=template&id=373f5a10&scoped=true", function () {
      api.rerender('373f5a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/versionUpdate/VersionUpdateList.vue"
export default component.exports